module.exports = __webpack_public_path__ + "static/media/radiation.c54484bc.svg";